import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import { ContractStatusEsEnum } from "@edp-enums/ES/contract-status-es-enum";
import { IPropertyType } from "@edp-components/edp-contract/edp-contract.model";
import { ContractEs } from "@edp-models/ES/es-contract.model";
import { ContractTypeEsEnum } from "@edp-enums/ES/contract-type-es-enum";

@Component({
    selector: "edp-es-contract-local-card",
    templateUrl: "./edp-es-contract-local-card.component.html",
    styleUrls: ["./edp-es-contract-local-card.component.scss"],
})
export class EdpEsContractLocalCardComponent implements OnInit {
    @Input() contract: ContractEs;
    @Input() selected: ContractEs;
    @Output() selectedContract: EventEmitter<ContractEs> = new EventEmitter<ContractEs>();

    public isInactived = false;
    public type: IPropertyType;
    public fullAddress: string;
    public ContractStatusEnum = ContractStatusEsEnum;
    public alerts = 0; // TODO - change later with BE response
    public contractTypeLabel: string;

    ngOnInit() {
        this.contractTypeLabel =
            this.contract.type === ContractTypeEsEnum.LIGHT_AND_GAS
                ? "edp.edponline.contract.local.card.footer.contract.type.electric"
                : "edp.edponline.contract.local.card.footer.contract.type.solar";
        this.fullAddress = this.contract.getAddress();
        this.isInactived = this.contract.status === ContractStatusEsEnum.CANCELLED;
    }

    public selectContract = (contract: ContractEs) => {
        this.selectedContract.emit(contract);
    };
}
